import { SmartAmpStatus } from './smart-amp-sse-helpers';

export type SmartPlugStatus = 'inactive' | 'active' | 'stopped';

/** SmartPlug uses the shared SmartAmp SSE state, with charger-limited status presented as stopped. */
export function toSmartPlugStatus(status: SmartAmpStatus): SmartPlugStatus {
  if (status === 'chargingLimited') return 'stopped';
  return status;
}

/** Current charging power as a percentage of the charger's rated output, or `null` while either is unknown. */
export function getChargingSpeedPercentage(currentPower: number | null, ratedOutput: string): number | null {
  const ratedPower = Number.parseFloat(ratedOutput.replace(',', '.'));
  if (currentPower === null || !Number.isFinite(currentPower) || !Number.isFinite(ratedPower) || ratedPower <= 0) {
    return null;
  }

  return Math.min(100, Math.max(0, (Math.abs(currentPower) / ratedPower) * 100));
}
